import { Component, Input } from '@angular/core';
import { IStorageStats } from 'src/app/utils/interfaces';
import { StoragesService } from '../storage.service';

@Component({
  selector: 'app-storage-stats',
  templateUrl: './storage-stats.component.html',
  styleUrls: ['./storage-stats.component.scss']
})
export class StorageStatsComponent {
  @Input() stats: IStorageStats;

  constructor(private storage: StoragesService) {
    return;
  }

  public load(): void {
    this.storage.refreshStorageInfo();
  }
  public clear(): void {
    this.storage.clearStorage();
  }

  public clearTestData(): void {
    this.storage.removeTestData('HEHEH	').subscribe();
  }
}
